export class Zone {
  code: number;
  description: string;
}
